import firebase from "firebase";
import "firebase/firestore";

//firebase inits
const firebaseConfig = {
  apiKey: "AIzaSyCMpUiVNnS0IyRbLLqRDuU79_emVTfhNFo",
  authDomain: "csgo-auction.firebaseapp.com",
  databaseURL: "https://csgo-auction.firebaseio.com",
  projectId: "csgo-auction",
  storageBucket: "csgo-auction.appspot.com",
  messagingSenderId: "209467909390",
  appId: "1:209467909390:web:286bf33aac3e9522"
};

firebase.initializeApp(firebaseConfig);

//firebase utilities

const db = firebase.firestore();
const storage = firebase.storage();
const auth = firebase.auth();
const currentUser = auth.currentUser;

//firebase collections
const announcementsCollection = db.collection("announcements");
const playersCollection = db.collection("players");
const teamsCollection = db.collection("teams");
const adminsCollection = db.collection("admins");
const auctionCollection = db.collection("auction");
const fixturesCollection = db.collection("fixtures")
export {
  db,
  storage,
  auth,
  currentUser,
  announcementsCollection,
  playersCollection,
  adminsCollection,
  teamsCollection,
  auctionCollection,
  fixturesCollection
};
